import statistic from './statistic'

export default {
  settings: {
    hasOvertime: true,
    hasShootouts: true,
    hasDelayedEvents: true
  },
  actionTypes: {
    numberOfPlayersChangeEvents: [
      'RED_CARD',
      'PLAYER_ON_PITCH'
    ]
  },
  modules: {
    info: [
      'timer',
      {
        type: 'players',
        props: {
          home: ingameData => ingameData.playersCount.home,
          away: ingameData => ingameData.playersCount.away
        }
      },
      {
        type: 'periods',
        props: {
          className: 'liveCardPeriods__slider_left'
        }
      }
    ],
    score: {
      component: 'score-component',
      score: ingameData => ingameData.score
    },
    fieldScheme: {
      component: 'football-field'
    },
    statistic,
    eventLog: true
  },
  storeScheme: {
    score: {
      home: 0,
      away: 0
    },
    playersCount: {
      home: 4,
      away: 4
    },
    shootoutsLog: {
      home: [],
      away: []
    },
    getOvertimePeriodName: 'ET',
    shootoutPeriodName: 'P'
  }
}
